export default {
  authLogin: (state, auth) => {
    state.authToken = auth.authToken
    state.userDetails = auth.user
    state.isLoggedIn = true
  },
  logout: (state) => {
    state.isLoggedIn = false
    state.authToken = ''
  },
  showDeleteDialog: (state, data) => {
    state.dialogOkCb = data.dialogOkCb || function () { }
    state.dialogCancelCb = data.cancelCb || function () { }
    state.isLocalDelete = data.isLocalDelete || false
    /*  */
    state.deletePayload = data
    state.showDialog = true
  },
  rememberOrder: (state, obj) => {
    state[obj.type] = obj.data
  },
  setWorkflowList: (state, data) => {
    state.workFlowStates = data
  },
  applyFilterOnOrder: (state, obj) => {
    state.filterByActiveUser = obj
  },
  isChangesMade (state, data) {
    state.isChangesMade = data
  },
  changeLostDialog (state, data) {
    state.changeLostDialog = data
  },
  // REMEBER FILTERS
  rememberFilter (state, obj) {
    state[obj.type] = obj.data
  },
  supportingList: (state, data) => {
    state.supportList = data
  },
  listValues: (state, obj) => {
    state[obj.type] = obj.data
  },
  showFullLoader: (state) => {
    state.showFullLoader = true
  },
  hideFullLoader: (state) => {
    state.showFullLoader = false
  }, // dialog
  showDialog (state, data) {
    state.dialogOkCb = data.dialogOkCb || function () {}
    state.dialogCancelCb = data.cancelCb || function () {}
    state.showDialog = true
  },
  dialogOk (state) {
    state.dialogOkCb()
    state.showDialog = false
  },
  hideDialog (state) {
    state.showDialog = false
  }
}
